import { render, staticRenderFns } from "./DashboardLinksPagination.vue?vue&type=template&id=448cd6ab&"
import script from "./DashboardLinksPagination.vue?vue&type=script&lang=js&"
export * from "./DashboardLinksPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports